export default __webpack_public_path__ + "static/media/bannerContacto.6e9b2919.png";